import { PropsWithChildren, useState } from "react";
import { TransferButton } from "./TransferButton";
import TokenTransferModal from "./TokenTransferModal";
import useInvalidateQuery from "@/src/hooks/useInvalidateQuery";
import { USER_NFTS } from "@/libs/apis/onboarding/reactQueryCacheKeys";
import { useTokenTransferAnalytics } from "./TokenTransferModal/hooks/analytics";

export type TokenTransferToken = {
  name?: string;
  id?: string;
  contractAddress?: string;
  image?: { src?: string; alt?: string };
};

export type TokenTransferModuleProps = {
  token: TokenTransferToken;
  swooshHandle?: string;
  collectionSlug?: string;
};

export default function TokenTransferModule({
  token,
  swooshHandle,
  collectionSlug,
}: PropsWithChildren<TokenTransferModuleProps>) {
  const invalidateQuery = useInvalidateQuery();
  const sendAnalytics = useTokenTransferAnalytics(
    token,
    collectionSlug,
    swooshHandle,
  );

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const openModal = () => {
    sendAnalytics.tokenTransferInitiated();
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    invalidateQuery([USER_NFTS, swooshHandle ?? ""]);
  };

  return (
    <>
      <TransferButton onClick={openModal} />
      <TokenTransferModal
        token={token}
        isOpen={isModalOpen}
        onClose={closeModal}
        collectionSlug={collectionSlug ?? ""}
        swooshHandle={swooshHandle ?? ""}
      />
    </>
  );
}
